import * as Yup from 'yup';

export const serviceSchema = Yup.object().shape({
    name: Yup.string('Это не строка').required('Полное наименование услуги'),
});
